import React, { useEffect, useMemo, useState } from "react";

import FlightPageSearchBar from "./Flights/HomePageSearchBar";
import HotelPageSarchBar from "./Hotels/HomePageSearchBar";
import PackagePageSarchBar from "./Packages/HomePageSearchBar";
import "./HomePage.css";

export default function HomePage({ type }) {
  return (
    <div className="homepage screen">
      <div className="frame-101">
        <div className="frame-203">
          <p className="book-international-and-domestic-flights valign-text-bottom proxima_semibold color_white font25">
            Book International And Domestic Flights
          </p>
        </div>

        {(type === "flights" || type === undefined) && <FlightPageSearchBar />}
        {type === "hotels" && <HotelPageSarchBar />}
        {type === "packages" && <PackagePageSarchBar />}

        {/* <OffersSection header={1} /> */}

        {/* <OffersSection header={2} />

        <PopularDestinations /> */}
      </div>
    </div>
  );
}
